export const ApplicationStates = {
    FORM: 1,
    FORM_LAST_STEP: 2,
    BANK_VERIFICATION: 3,
    CHOOSE_OFFER: 4,
    SIGN_CONTRACT: 5,
    MANUAL_VERIFICATION_CLIENT_CHOICE: 6,
    FOUNDS_WITHDRAWAL: 7,
}